export const ADD_TAG = 'ADD_TAG';
export const addTag = ({label, section}) => {
  if (['monitoring', 'assessment', 'controlRules'].indexOf(section) === -1) {
    throw new Error(`Unknown section ${section}`);
  }
  return {
    type: ADD_TAG,
    label: label,
    section: section
  }
}

export const DELETE_TAG = 'DELETE_TAG';
export const deleteTag = (id) => ({
  type: DELETE_TAG,
  id
})

export const UPDATE_TAG = 'UPDATE_TAG';
export const updateTag = ({id, label}) => ({
  type: UPDATE_TAG,
  id,
  label
})
